import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { SharedService } from 'app/shared/service/shared.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import { AuthenticatedUserDto } from 'shared/service-proxies/models/authenticated-user-dto.model';
import { ChangePasswordDto } from 'shared/service-proxies/models/change-password-dto.model';
import { UserServiceProxy } from 'shared/service-proxies/services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  password: any;
  isDefaultPasswordChange: boolean = true;
  confirmPassword: any;
  changePassword: ChangePasswordDto = new ChangePasswordDto();
  changePassDialog: boolean = false;
  currentUser: AuthenticatedUserDto = new AuthenticatedUserDto();
  constructor(private _userServiceProxy: UserServiceProxy,
    private _toasterService: ToasterService,
    private _localStorageService: LocalStorageService,
    private _sharedService: SharedService) { }

  ngOnInit(): void {    
    this.isDefaultPasswordChange = this._localStorageService.getData(LocalStorage.ISCHANGEPASSWORDOPENED) == null ? true : this._localStorageService.getData(LocalStorage.ISCHANGEPASSWORDOPENED);
    this.password = null;
    this.confirmPassword = null;
    this.changePassword = new ChangePasswordDto();
    this.currentUser = this._localStorageService.getData(LocalStorage.CURRENT_USER);
    this._sharedService.openChangePassword.subscribe(isOpen => {
      this.changePassDialog = isOpen;
    })
    // 
    // this.changePassDialog = this._sharedService.openChangePassword;
  }

  open() {
    this.changePassDialog = true;
  }


  savePassword() {
    if (this.changePassword.password == this.confirmPassword) {
      this.changePassword.id = this.currentUser.id;
      this._userServiceProxy.changePassword(this.changePassword).subscribe(response => {
        if (response.isSuccess) {
          this.isDefaultPasswordChange = true;
          this._localStorageService.deleteData(LocalStorage.ISCHANGEPASSWORDOPENED)
          this._toasterService.toastSuccess("Password Change Successfully")
          this.changePassDialog = false;
          this.changePassword = new ChangePasswordDto();
          this.confirmPassword = null;
        }
        else {
          this._toasterService.showApiValidation(response);
        }
      })
    }
    else {
      this._toasterService.toastError("Confirm Password not match");
    }
  }
  hideDialog() {
    if (this.isDefaultPasswordChange == true) {
      this.changePassword = new ChangePasswordDto();
      this.changePassDialog = false;
      this.confirmPassword = null;

    }
  }
}
